import { CSSObject } from "@emotion/react";

import {
  bodyFontSizeMapping,
  bodyLineHeight,
  headingFontSizeMapping,
  headingLineHeightMapping,
} from "@/view/constants/styles/accessibleFontSizeMapping/accessibleFontSizeMapping.style";

export const getEditorContentWrapperStyles = (
  currentFontSize: keyof typeof bodyFontSizeMapping,
): CSSObject => {
  const paragraphFontSize = bodyFontSizeMapping[currentFontSize];
  const h2FontSize = headingFontSizeMapping(true)[currentFontSize];
  const h2LineHeight = headingLineHeightMapping(true)[currentFontSize];
  const h3FontSize = headingFontSizeMapping()[currentFontSize];
  const h3LineHeight = headingLineHeightMapping()[currentFontSize];

  return {
    p: {
      fontSize: paragraphFontSize,
      lineHeight: bodyLineHeight,
    },
    h2: {
      fontSize:
        typeof h2FontSize === "string" ? h2FontSize : h2FontSize.fontSize,
      lineHeight: h2LineHeight,
    },
    h3: {
      fontSize:
        typeof h3FontSize === "string" ? h3FontSize : h3FontSize.fontSize,
      lineHeight: h3LineHeight,
    },
    marginBottom: "3rem",
  };
};
